import get from 'lodash/get';

export const getVulnValue = (vuln) => vuln?.value ?? vuln ?? {};

export const getVulnId = (vuln) => {
  const value = getVulnValue(vuln);
  return get(value, '_id', get(value, 'id', get(vuln, '_id', get(vuln, 'id', null))));
};

export const normalizeVulnId = (id) => {
  if (id === null || typeof id === 'undefined' || id === '') return null;
  return String(id);
};

export const sameVulnId = (firstVuln, secondVuln) => {
  const firstId = normalizeVulnId(getVulnId(firstVuln));
  const secondId = normalizeVulnId(getVulnId(secondVuln));

  return firstId !== null && secondId !== null && firstId === secondId;
};

export const normalizeVulnIds = (vuln = {}) => {
  const id = getVulnId(vuln);
  if (id === null || typeof id === 'undefined') return vuln;

  const currentId = get(vuln, 'id', undefined);
  const currentUnderscoreId = get(vuln, '_id', undefined);

  return {
    ...vuln,
    id: currentId !== null && typeof currentId !== 'undefined' ? currentId : id,
    _id: currentUnderscoreId !== null && typeof currentUnderscoreId !== 'undefined' ? currentUnderscoreId : id
  };
};

export const uniqueVulnsById = (vulns = []) => {
  const ids = new Set();

  return vulns.filter((vuln) => {
    const id = normalizeVulnId(getVulnId(vuln));
    if (id === null) return true;
    if (ids.has(id)) return false;

    ids.add(id);
    return true;
  });
};
